import styled from 'styled-components'

export const Title = styled.p`
  font-size: 18px;
  line-height: 24px;
  margin: 24px 0;
  color: ${({ theme }) => theme.colors.secondary.normal};
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 24px;
    line-height: 32px;
  }
`

export const Description = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey84};
  text-align: center;

  &:last-child {
    margin: 20px 0 12px;
  }
`

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
